exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#config-page[data-v-fd841328]{width:750px;margin:20px auto}#config-page .header[data-v-fd841328]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}#config-page .header .title[data-v-fd841328]{font-weight:700;font-size:24px}#config-page .button-wrapper[data-v-fd841328]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}", ""]);

// exports
